import { IpAddresses } from "../../Constants/constants";

export const getFollowersAndFollowing = async (input) =>{
    let URL = IpAddresses.flaskUrl+"/get_all_ff";    
    let options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'            
        },
        body: JSON.stringify(input)
    }
    try{
        let response = await fetch(URL, options)
        let json = await response.json()
        return json
    }catch(err){
        if(err.message == "Network request failed"){
            return {
                "errorMessage": "Network Error: Check your internet connection"
            }
        }else{            
            return{
                "errorMessage": "Error"
            }
        }        
    }
}

export const follow_and_unfollow =  async (input) =>{
    let URL = IpAddresses.flaskUrl+"/follow_and_unfollow"
    let options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',            
        },
        body: JSON.stringify(input)
    }
    try{
        let response = await fetch(URL, options)
        let json = await response.json()
      
        if(response.status == 200) {
            
            return json
        } else {
            let errStr = Object.values(json)[0][0]
            return {"error": errStr}
        }
    }catch(err){
        if(err.message == "Network request failed"){
            return {
                "errorMessage": "Network Error: Check your internet connection"
            }
        }else{
          
            return{
                "errorMessage": "Error creating post, try again later"
            }
        }        
    }
}

export const setPlaylistFlask = async (input) =>{
    let URL = IpAddresses.flaskUrl+"/send_spotify_playlist";
    ////console.log(URL);    
    let form = new FormData()    
    let options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(input)
    }
    try{
        let response = await fetch(URL, options)
       return response
        console.log(response.status)       
    }catch(err){
        if(err.message == "Network request failed"){
            return {
               status:500
            }
        }else{         
            return{
                status:500
            }
        }        
    }
}

